function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#F1904C;}\n\t.st1{fill:#080909;}\n\t.st2{fill:#FFFFFF;}\n");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M224.8,262.1H45.8c-2.9,0-5.2-2.3-5.2-5.2V32c0-2.9,2.3-5.2,5.2-5.2h178.9c2.9,0,5.2,2.3,5.2,5.2V257 C229.9,259.8,227.6,262.1,224.8,262.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M226.7,264.9H43.8c-3.3,0-6-2.7-6-6V30.1c0-3.3,2.7-6,6-6h182.9c3.3,0,6,2.7,6,6V259 C232.7,262.2,230,264.9,226.7,264.9z M43.8,29.7c-0.2,0-0.4,0.2-0.4,0.4V259c0,0.2,0.2,0.4,0.4,0.4h182.9c0.2,0,0.4-0.2,0.4-0.4 V30.1c0-0.2-0.2-0.4-0.4-0.4H43.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M102.4,81.8c10.3-3.5,21.9-3.6,32.7-4c10.5-0.1,23.2-0.1,33.2,3.3c4.9,1.6,10.6,5.3,13,10.1 c4.5,8.6,5,22.2,5.1,31.5c-5,0-13.9,0-18.7,0c-0.1-7,0.7-15.5-2.4-22c-2-4.3-6.9-5.5-11.1-6.2c-8.8-1.4-17.7-0.9-26.5-0.6 c-7,0.5-14.2,0.8-20.8,3.5c-4.3,1.6-6.2,6.3-7.3,10.5c-2.6,10.8-1.5,22.1-1.8,33.1c0.5,14.8,0.3,29.8,3,44.5 c0.6,4.4,3.4,8.2,7.5,9.9c8.9,3.9,18.8,3.7,28.2,3.8c8.2-0.3,16.7-0.3,24.6-2.8c3.4-1,5.8-4.1,6.9-7.5c2.2-6.9,1.9-16.1,1.6-23 c4.7,0,13.8-0.1,18.8,0c0,9.8,0.2,22.1-3.5,31.6c-1.6,4.1-3.7,8.5-9.4,11.6c-7.1,3.8-18.4,4.2-26.1,4.9 c-12.2,0.7-24.5,1.1-36.7-0.8c-7.4-1.3-17.8-3.9-23.6-10.5c-5.1-5.8-6.6-15.3-7.9-22.6c-2.7-18.6-2.1-37.5-1.8-56.2 c0.5-7.5-0.2-16.6,2.5-23.8C85.8,90.2,94.9,84.4,102.4,81.8z"
}));

const SvgCleverTap = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 268.5 283",
  style: {
    enableBackground: "new 0 0 268.5 283"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCleverTap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clever_tap.f40451df.svg";
export { ForwardRef as ReactComponent };